import React, {FunctionComponent} from "react";
import {Color} from "../../../utils/color";
import Icon, {IconProps} from "../icon/Icon";
import IconTooltip from "../icon/IconTooltip";
import InputText, {InputTextProps} from "./InputText";
import clsx from "clsx";

export type InputWithActionProps = InputTextProps & {
    action: {
        icon: IconProps;
        text: string;
        onClick?: (e: React.MouseEvent) => void;
        disabled?: boolean;
    };
};

const InputWithAction: FunctionComponent<InputWithActionProps> = ({action, cssClass, ...inputAttr}) => {
    return (
        <div className={clsx("input-with-button", cssClass)}>
            <InputText {...inputAttr}/>
            <span className="input-with-button__separator"/>
            <span className="input-with-button__action">
                {action.disabled ?
                    <Icon
                        {...action.icon}
                        colorIcon={Color.GREY}
                        cssClass="input-with-button__icon"
                    /> :
                    <IconTooltip
                        icon={{...action.icon, cssClass: "input-with-button__icon"}}
                        text={action.text}
                        onClick={action.onClick}
                    />
                }
            </span>
        </div>
    );
};

export default InputWithAction;
